<template>
  <section class="py-12">
    <div class="container-wrap">
      <div class="w-full" :class="contentClass">
        <div :class="direction === 'horizontal' && 'tablet:w-6/12 tablet:pr-6'">
          <p
            v-if="contextData.sectionName"
            class="text-sm font-bold text-gray-600"
          >
            {{ contextData.sectionName }}
          </p>
          <h2 class="text-h2 mb-6">{{ contextData.title }}</h2>
        </div>
        <ul :class="direction === 'horizontal' && 'tablet:w-6/12'">
          <li v-for="(item, index) in contextItems" :key="item.name">
            <SuiteTopicsFaqCard :item-data="item" :default-show="index === 0" />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    description: string;
  }

  interface IFaqData {
    sectionName?: string;
    title: string;
    items: IItem[];
    direction?: 'horizontal' | 'vertical';
  }

  interface IFaq {
    component: 'topics-faq';
    meta: {
      navigable?: string;
    };
    data: IFaqData;
  }

  type IProps = ISuiteProps<IFaq>;

  const props = defineProps<IProps>();

  const contextData = computed((): IFaqData => props.suiteData.data);

  const contextItems = computed((): IItem[] => contextData.value.items);

  const direction = computed(() => contextData.value.direction || 'vertical');

  const contentClass = computed((): string => {
    return direction.value === 'horizontal'
      ? 'tablet:flex'
      : 'mx-auto max-w-[760px]';
  });

  export type { IFaq, IFaqData, IItem };
</script>
